<template>
  <section id="download-app" class="py-16 lg:py-24 relative overflow-hidden">
    <div class="absolute inset-0 bg-slate-900"></div>
    <div class="absolute top-0 right-0 w-full h-full bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-pink-500/20 via-slate-900 to-slate-900"></div>

    <div class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
      <h2 class="text-3xl sm:text-4xl md:text-5xl font-black text-white mb-4 sm:mb-6">לעסק שלכם מגיע יותר. לכם מגיע יותר.</h2>
      <p class="text-base sm:text-xl text-slate-300 mb-8 sm:mb-10 max-w-2xl mx-auto">
        הצטרפו עוד היום לאפליקציה שכבר שינתה את החיים לבעלי עסקי בתחום הביוטי והוולנס בישראל.
      </p>

      <div class="flex flex-col items-center gap-6 sm:gap-8">
        <button @click="goToLogin" class="bg-gradient-to-r from-pink-500 to-purple-600 hover:from-pink-400 hover:to-purple-500 text-white text-lg sm:text-xl px-8 sm:px-12 py-3 sm:py-5 rounded-full font-bold transition-[transform,background] shadow-lg shadow-pink-500/30 transform hover:-translate-y-1 w-full sm:w-auto">
          הרשמו עכשיו
        </button>

        <div class="w-full">
          <p class="text-slate-400 font-medium  mb-3 sm:mb-4">או הורידו את האפליקציה ישירות למובייל:</p>
          <div class="flex flex-row justify-center gap-3 sm:gap-4">
            <a target="_blank" :href="appStoreUrl('final_cta')" @click="posthog.capture('app_store_clicked', { source: 'final_cta' })" class="flex items-center gap-2 bg-slate-900 hover:bg-black text-white border border-slate-700 px-3 sm:px-4 py-2 rounded-xl transition-[transform,box-shadow] shadow-md hover:shadow-lg hover:-translate-y-0.5 w-[140px] sm:w-[160px]">
              <svg viewBox="0 0 384 512" class="w-5 h-5 sm:w-6 text-white sm:h-6 fill-current shrink-0"><path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"/></svg>
              <div class="text-right flex flex-col justify-center">
                <span class="text-[9px] sm:text-[10px] leading-none mb-1 text-slate-300">להורדה מ-</span>
                <span class="text-xs sm:text-sm font-bold leading-none font-sans text-white" dir="ltr">App Store</span>
              </div>
            </a>
            <a target="_blank" :href="googlePlayUrl('final_cta')" @click="posthog.capture('google_play_clicked', { source: 'final_cta' })" class="flex items-center gap-2 bg-slate-900 hover:bg-black text-white border border-slate-700 px-3 sm:px-4 py-2 rounded-xl transition-[transform,box-shadow] shadow-md hover:shadow-lg hover:-translate-y-0.5 w-[140px] sm:w-[160px]">
              <svg viewBox="0 0 512 512" class="w-5 h-5 sm:w-6 sm:h-6 fill-current shrink-0 text-emerald-400"><path d="M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z"/></svg>
              <div class="text-right flex flex-col justify-center">
                <span class="text-[9px] sm:text-[10px] leading-none mb-1 text-slate-300">להורדה מ-</span>
                <span class="text-xs sm:text-sm font-bold leading-none font-sans text-white" dir="ltr">Google Play</span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';
import posthog from 'posthog-js';
import { appStoreUrl, googlePlayUrl } from '@app/consts/store-links';
import { goTo } from '@app/utils';

const router = useRouter();

const goToLogin = (): void => {
  posthog.capture('final_cta_register_clicked');
  goTo('register')
};
</script>
